import { render, staticRenderFns } from "./SurgerySuccess.vue?vue&type=template&id=3468bf91&scoped=true"
import script from "./SurgerySuccess.vue?vue&type=script&lang=js"
export * from "./SurgerySuccess.vue?vue&type=script&lang=js"
import style0 from "./SurgerySuccess.vue?vue&type=style&index=0&id=3468bf91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468bf91",
  null
  
)

export default component.exports